export const calculateItemPrice = (item) => {
  if (!item) return 0;
  
  // Handle both nested and flat structures
  const price = parseFloat(item.medicine?.price || item.price || 0);
  const quantity = parseInt(item.quantity || 0);
  const discount = parseFloat(item.discount || 0);

  return price * quantity * (1 - discount / 100);
};

export const calculateSubTotal = (items) => {
  if (!items) return 0;
  
  return items.reduce((total, item) => 
    total + calculateItemPrice(item), 0
  );
};

export const calculateTotal = (items, additionalCharges) => {
  if (!items) return "0.00";
  
  const subtotal = calculateSubTotal(items);
  const chargesTotal = (additionalCharges || []).reduce(
    (sum, charge) => sum + parseFloat(charge.amount || 0), 0
  );
  
  return (subtotal + chargesTotal).toFixed(2);
};

export const calculateTotalMRP = (items) => {
  if (!items) return 0;
  
  return items.reduce((total, item) => {
    const price = parseFloat(item.price || item.medicine?.price || 0);
    const quantity = parseInt(item.quantity || 0);
    return total + (price * quantity);
  }, 0);
};

export const calculateTotalDiscount = (items) => {
  if (!items) return 0;
  
  const totalMRP = calculateTotalMRP(items);
  const subtotal = calculateSubTotal(items);
  return totalMRP - subtotal;
};

export const calculateDiscountPercentage = (items) => {
  if (!items) return "0.0";
  
  const totalMRP = calculateTotalMRP(items);
  const totalDiscount = calculateTotalDiscount(items);
  return totalMRP > 0 ? ((totalDiscount / totalMRP) * 100).toFixed(1) : "0.0";
}; 